import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { type X5Machine } from "@packsize/schemas/machines";

import { getX5Machines } from "@/api/machines/x5-api-v2";

import { type UseMachinesQueryOptions } from "../types";

import { X5_MACHINES_QUERY_KEY } from "./query-keys";

const REFETCH_INTERVAL = 15 * 1000;

export const getX5MachinesQuery = <TData = X5Machine[], TError = Error>(
	options?: UseMachinesQueryOptions<TData, TError>,
) => ({
	queryKey: X5_MACHINES_QUERY_KEY,
	queryFn: getX5Machines,
	refetchInterval: REFETCH_INTERVAL,
	staleTime: 10 * 1000,
	...options,
});

export const useX5Machines = (
	options?: UseMachinesQueryOptions<X5Machine[], Error>,
): UseQueryResult<X5Machine[], Error> => {
	return useQuery<X5Machine[], Error>(getX5MachinesQuery(options));
};
